<!-- 百分比上传组件 -->
<template>
  <div class="load-btn">
    <el-upload ref="upload" :disabled="upState == 'loading'" class="upload-btn" :action="upUrl" :headers="postHead"
      :before-upload="prevCtrls" :on-progress="pgressCtrls" :on-error="errorCtrls" :on-success="successCtrls"
      :show-file-list="false" :data="fileData" multiple :limit="3" :on-exceed="handleExceed" :submit="upUrl">
      <el-button :disabled="upState == 'loading'" size="small">
        <span v-if="upState == 'wait' || upState == 'loading'">上传</span>
        <span v-if="upState == 'loaded'">更新</span>
        
      </el-button>
      <!-- <el-button circle size="small" type="primary" icon="el-icon-arrow-left" @click="handleLeftRotate(imgUrl)">
       
      </el-button>
      <el-button circle size="small" type="primary" icon="el-icon-arrow-right" @click="handleRightRotate(imgUrl)">
        
      </el-button> -->
      <!--    <el-button slot="trigger" size="small" type="primary">上传</el-button>-->
      <!--    <el-button style="margin-left: 10px;" size="small" type="success" @click="submitUpload">上传到服务器</el-button>-->
      <div v-if="needTip!='no'" class="tips" style="margin-left:12px;">注：上传文件格式为JPEG/PNG，文件大小不超过10M</div>
    </el-upload>

    <div class="progressBox">
      <el-progress v-show="upState == 'loading'" :stroke-width="9" :percentage="percentage"></el-progress>
    </div>
    <div v-show="upState == 'loaded'" class="imgBox">
      <img @click="dialogVisible = true" :src="imgUrl" />
      <!-- <div class="rotate icon" @click.stop="handleRotate" /> -->
    </div>
    <!-- <div>
      <div class="edName uploadLine"></div>
      <div class="icons" style="padding-left:5px;">
        <img src="../../assets/images/left.png" @click="handleLeftRotate(imgUrl)">
        <img src="../../assets/images/right.png" @click="handleRightRotate(imgUrl)">
        <el-button type="primary" size="small" @click="submitUpload">保存</el-button>
      </div>
    </div> -->

    <!-- <el-dialog :visible.sync="dialogVisible">
      <img width="100%" :src="imgUrl" alt="">
      
    </el-dialog> -->

    <el-dialog :visible.sync="dialogVisible" center style="margin:auto;">
      <img width="100%" :src="imgUrl" alt="">
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleLeftRotate(imgUrl)">
          <img src="../../assets/images/left.png">
        </el-button>
        <el-button @click="handleRightRotate(imgUrl)">        
          <img src="../../assets/images/right.png">
        </el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
  import {
    getToken
  } from '@/utils/auth';
  import {
    rotateImg,
    rotateImgBase64,
    dataURLtoFile
  } from '@/components/ImgFilp/canvas-rotate-image';
  import {
    getFileToken
  } from '@/api/account';
  import {
    getPfileUrl
  } from '@/api/pressRole/pressRole';
  import {
    uploadBase64
  } from '@/api/file';
  export default {
    props: ['ableSure', 'needTip'],
    data() {
      return {
        dialogVisible: false,
        percentage: 0,
        upState: 'wait',
        fileData: {},
        imgUrl: '',
        fileToken: '',
        upUrl: '',
        postHead: {},
        disabled: false
      }
    },
    watch: {
      ableSure: function (dat) {
        this.imgInit(this.ableSure);
      }
    },
    methods: {
      // 左转
      handleLeftRotate(imgUrl) {
        const that = this;
        if (imgUrl.toString().startsWith("http")) {
          rotateImg(imgUrl, -90, function (base64) {
            that.imgUrl = base64;
            // 保存旋转效果
            that.submitUpload();
          });
        } else {
          rotateImgBase64(imgUrl, -90, (base64) => {
            that.imgUrl = base64;
            // 保存旋转效果
            that.submitUpload();
          });
        }
      },
      // 右转
      handleRightRotate(imgUrl) {
        const that = this;
        if (imgUrl.toString().startsWith("http")) {
          rotateImg(imgUrl, 90, (base64) => {
            that.imgUrl = base64;
            // 保存旋转效果
            that.submitUpload();
          });
        } else {
          rotateImgBase64(imgUrl, 90, (base64) => {
            that.imgUrl = base64;
            // 保存旋转效果
            that.submitUpload();
          });
        }

      },
      //手动提交图片
      submitUpload() {
        // this.$refs.upload.submit();
        if (!this.imgUrl.toString().startsWith("http")) {
          uploadBase64({ ableSure: this.ableSure ,base64:this.imgUrl});
        }
      },
      // 移除图片
      handleRemove(file, fileList) {
        console.log(file, fileList);
      },
      // 图片预览
      handlePreview(file) {
        console.log(file);
      },
      // 图片上传前的判断
      prevCtrls: function (file) {
        let nameArr = file.type.split('/');
        let fileType = nameArr[nameArr.length - 1];

        if (fileType != 'jpeg' && fileType != 'png') {
          this.$message({
            message: '请上传格式为 JPGE 或 PNG 的文件！',
            type: 'error'
          })
          return false;
        } else if (file.size / 1024 / 1024 > 10) {
          this.$message({
            message: '文件大小不能超过 10M！',
            type: 'error'
          })
          return false;
        } else {
          this.percentage = 0;
          this.upState = 'loading';
          this.postHead['Authorization'] = `Bearer ${getToken()}`;
          // this.fileData.token = getToken();
          this.fileData.fileSize = file.size;

          return true;

        }
      },
      pgressCtrls: function (evt, file) {
        this.percentage = parseInt(file.percentage);
      },
      errorCtrls: function (err) {
        this.upState = "wait";
        this.$alert('上传失败，请稍后重试！', '提示', {
          confirmButtonText: '确定',
          type: 'error'
        })
      },
      successCtrls: function (data) {
        console.log(data)
        if (data.code && data.code != 0) {
          this.upState = "wait";
          this.$alert(`上传失败.     ${data.message || data.error}`, '提示', {
            confirmButtonText: '确定',
            type: 'error'
          })
          return
        }
        this.percentage = 100;
        // this.ableSure = data.payload.id;
        this.imgInit(data.payload.id);
        this.$emit('upFileId', data.payload.id);
      },

      imgInit: function (dat) {
        if (dat) {
          this.upState = 'loaded';
          // this.imgUrl = process.env.BASE_API + '/File/File/view/token/' + this.fileToken + '/id/' + dat;
          getPfileUrl({
            id: dat
          }).then(response => {
            this.imgUrl = response.payload.url+"?"+new Date().getTime();
          })
        }
      },

      handleExceed: function () {

      }
    },

    created: function () {
      // this.upUrl = process.env.BASE_API + '/File/File/upload';
      this.upUrl = process.env.BASE_API + '/eavar/file/upload';
      getFileToken().then(response => {
        this.fileToken = response.resultStatus.token;
        this.imgInit(this.ableSure);
      })

    }
  }
</script>

<style scope>
  .upload-btn {
    display: inline-block;
  }

  .progressBox {
    width: 480px;
    margin-top: 6px;
  }

  .imgBox {
    height: 120px;
    margin-bottom: 9px;
  }

  .imgBox img {
    height: 100%;
    cursor: pointer;
  }
</style>


// WEBPACK FOOTER //
// uploadCards.vue?1bedb841